module.exports = __webpack_public_path__ + "img/referral-selected.790b0c23.png";